export default "__VITE_ASSET__BvOkSzJY__"